import { Component, Input, OnInit } from '@angular/core';
import { AppSettingsService } from '../app-settings/app-settings.service';
import { CurrencyService } from '../currency.service';

@Component({
	selector: 'app-currency-current',
	templateUrl: './currency-current.component.html',
	styleUrls: ['./currency-current.component.css']
})

export class CurrencyCurrentComponent implements OnInit {

	@Input('amount')amount: string;

	constructor(
		private appSettings: AppSettingsService,
		private currencyService: CurrencyService,
	) {}

	ngOnInit() {
		const registration_language: string = this.appSettings.data.user['registration_language'];
		const self = this;
		this.currencyService.getCurrenciesAsObject().then(res => {
			if (registration_language === 'pl') {
				self.amount = +self.amount * (res['PLN'] || res['PLN_CUSTOM']).ratio + ' zł';
			} else {
				self.amount = +self.amount * res['RUR'].ratio + ' ₽';
			}
		});
	}
}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/currency-current/currency-current.component.ts